<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!setting">
    <tt-card>
        <tt-tabs [(ttSelectedId)]="selectedBgAccumulationSelection" (ttSelectedIdChange)="onTabChanged()">
            <tt-tab ttId="A" ttLabel="componentpick_all"></tt-tab>
            <tt-tab ttId="1" ttLabel="componentpick_picked"></tt-tab>
            <tt-tab ttId="0" ttLabel="componentpick_not_picked"></tt-tab>
        </tt-tabs>
    </tt-card>

    <tt-list [ttData]="itemsListComponents"></tt-list>

    <tt-card>
        <tt-button-save *ngIf="setting.readytofinish === '0'" ttText="po_finish" (ttClick)="finishChanges()" [ttLoading]="finishing"></tt-button-save>
        <tt-button *ngIf="setting.readytofinish === '1'" ttText="po_finish_not_possible" ttType="danger"></tt-button>
        <tt-button ttText="pofinishprodlist_abort" (ttClick)="abortTask()" ttType="danger" [ttLoading]="aborting"></tt-button>
        <tt-button-settings></tt-button-settings>
    </tt-card>
</tt-page>
